// extracted by mini-css-extract-plugin
export default {"ModelPage":"Model_ModelPage__bu26D","ModelPage-Col":"Model_ModelPage-Col__LiR9-"};